var map = {
	"./4-track-glockenspiel_55.avif": 75222,
	"./4-track-music-box_55.avif": 69697,
	"./4-track-toy-piano_55.avif": 18956,
	"./dxtraterrestrial-1_55.avif": 41569,
	"./dxtraterrestrial-2_55.avif": 51494,
	"./edb-orgel_55.avif": 28384,
	"./elektrisk-salmesykkel_55.avif": 72137,
	"./lo-fi-tape-piano_55.avif": 68049,
	"./midnight-wurli_55.avif": 94257,
	"./omni-84_55.avif": 46701,
	"./strykebrett_55.avif": 72850,
	"./stylopoly_55.avif": 99750,
	"./subc_55.avif": 14200,
	"./voltage-controlled-cassette-organ_55.avif": 11859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36247;